import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.scss';
import logo from '../assets/images/logo-1.png';

const Footer = () => {
  const socialLinks = [
    { name: 'Facebook', url: 'https://facebook.com' },
    { name: 'Twitter', url: 'https://twitter.com' },
    { name: 'Instagram', url: 'https://instagram.com' },
    { name: 'LinkedIn', url: 'https://linkedin.com' }
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__main">
          <div className="footer__brand">
            <Link to="/" className="footer__logo">
              <img src={logo} alt="Skil.AI" style={{ height: '40px', width: 'auto' }} />
            </Link>
            <p className="footer__tagline">
              Building smart conversational virtual assistants that can bring omni-channel contextual conversations to life.
            </p>
          </div>

          <div className="footer__links">
            <div className="footer__column">
              <h3 className="footer__heading">PRIVACY POLICY</h3>
              <Link to="/privacy-policy" className="footer__link">
                Privacy Policy
              </Link>
            </div>

            <div className="footer__column">
              <h3 className="footer__heading">CONTACT DETAILS</h3>
              <p className="footer__contact">
                info@skil.ai
              </p>
              <p className="footer__contact">
                +1-619 373 1918
              </p>
            </div>

            <div className="footer__column">
              <h3 className="footer__heading">CONNECT WITH US</h3>
              <div className="footer__social">
                {socialLinks.map((social) => (
                  <a
                    key={social.name}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer__social-link"
                  >
                    {social.name}
                  </a>
                ))}
              </div>
            </div>

            <div className="footer__column">
              <h3 className="footer__heading">LOCATION</h3>
              <p className="footer__location">
                <strong>New Jersey :</strong><br />
                15 Corporate Pl S, Ste: 213B, Piscataway, NJ – 08854
              </p>
              <p className="footer__location">
                <strong>Visakhapatnam :</strong><br />
                3rd Floor TF1, VUDA Building, Seethammadara, Visakhapatnam, Andhra Pradesh 530013.
              </p>
            </div>
          </div>
        </div>

        <div className="footer__bottom">
          <div className="footer__copyright">
            <p>Copyright ©{new Date().getFullYear()} Skil, Inc. All Rights Reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 
